export default __webpack_public_path__ + "static/media/aoi.121f0dbf.png";